import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import Header from "../../../Header/Header";
import SideBar from "../../../SideBar/SideBar";
import Footer from "../../../Footer/Footer";
import logopart from "../../../../assets/img/icon.png";
import "../../../../components/pages/Reusecomponent/UniversityChatCard/universityChat.css";
import { Card, Select } from "antd";
import edudoc from "../../../../assets/img/edu.png";
import { useForm, useWatch } from "react-hook-form";
import {
  addCoApplicantsDetails,
  addReferenceDetails,
  addUserDetails,
  getCoApplicantByUserId,
  getReferenceByUserId,
  getUserByUserId,
  updateCoApplicantsDetails,
  updateReferenceDetails,
  updateUserDetails,
  uploadCoApplicantsDetails,
  uploadUserProfile,
} from "../../../HttpRequest/applyLoan";
import { Error, WarningAlert, topEndLoan } from "../../Base UI Elements/SweetAlert";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { handleMobileOtpSubmit, sendMoblieOTPapi } from "../../../HttpRequest/beforelogin";

export default function ApplyLoan() {
  const [userData, setUserData] = useState(true);
  const [userDoc1, setUserDoc1] = useState(false);
  const [userDoc2, setUserDoc2] = useState(false);
  const [userDoc3, setUserDoc3] = useState(false);
  const [docChanged, setdocChanged] = useState(false);
  const [reference1, setReference1] = useState(false);
  const [reference2, setReference2] = useState(false);
  const [coApplicant, setCoApplicant] = useState(false);
  const [veification, setVeification] = useState(false);
  const [coApplicantDoc, setCoApplicantDoc] = useState(false);
  const [userdocumentFiles, setUserDocumentFiles] = useState([]);
  const [coApplicantdocumentFiles, setCoApplicantDocumentFiles] = useState([]);

  const [usergetData, setUsergetData] = useState({
    adharCard: "",
    chooseBank: "",
    email: "",
    fullName: "",
    id: 0,
    inter: "",
    other: "",
    panCard: "",
    passport: "",
    passportSizePhoto: "",
    phoneNumber: "",
    planningTo: "",
    tenthClass: "",
    testScoreCards: "",
    underGraduation: "",
    workExperienceLetter: "",
    relivingLetter: "",
    paySlips: "",
    propertyDocuments: "",
    userId: 0,
  });

  const [uploadfilename, setuploadFileName] = useState({
    tenthClass: "",
    inter: "",
    btechIndividualMemos: "",
    btechTranscripts: "",
    consolidatedMarksMemo: "",
    provisionalCertificate: "",
    originalDegree: "",
    updatedResume: "",
    passportFront: "",
    passportBack: "",
    duolingo: "",
    gre: "",
    offerLetter: "",
    paySlips: "",
    bankStatementOfYourSalaryAccount: "",
    relievingLetter: "",
  });
  const [coapplicantGetData, setCoApplicantGetData] = useState({
    id: 0,
    ownHouseCoApplicant: "",
    coApplicantFullName: "",
    coApplicantRelationShip: "",
    coApplicantPhoneNumber: "",
    employmentType: "",
    panCard: "",
    adarCard: "",
    bankStatement: "",
    paySlips: "",
    userId: 0,
    itrform16: "",
  });

  const {
    register,
    handleSubmit,
    formState: { isDirty, isSubmitted, errors },
    setValue,
    watch,
  } = useForm();
  const {
    register: userRegister,
    formState: { errors: userErrors, isDirty: userForm },
    handleSubmit: userSubmit,
    setValue: userDetails,
  } = useForm();

  const {
    register: docRegister,
    formState: { errors: docErrors, isDirty: docForm },
    handleSubmit: docSubmit,
    setValue: docDetails,
  } = useForm();
  const {
    register: verificationRegister,
    formState: { errors: verificationErrors, isDirty: verificationForm },
    handleSubmit: verificationSubmit,
    setValue: verificationDetails,
  } = useForm();
  const {
    register: coApplicantDetailsRegister,
    formState: {
      errors: coApplicantDetailsErrors,
      isDirty: coApplicantDetailsForm,
    },
    handleSubmit: coApplicantDetailsSubmit,
    setValue: coApplicantDetailsDetails,
  } = useForm();

  const {
    register: personalRegister,
    formState: { errors: personalDocErrors, isDirty: personalDocForm },
    handleSubmit: personalDocSubmit,
    setValue: personalDocDetails,
  } = useForm();

  const {
    register: workRegister,
    formState: { errors: workDocErrors, isDirty: workDocForm },
    handleSubmit: workDocSubmit,
    setValue: workDocDetails,
  } = useForm();
  const {
    register: coApplicantRegister,
    formState: { errors: coApplicantErrors, isDirty: coApplicantForm },
    handleSubmit: coApplicantSubmit,
    setValue: coApplicantDetails,
  } = useForm();
  const {
    register: referenceRegister,
    formState: { errors: referenceErrors, isDirty: referenceForm },
    handleSubmit: referenceSubmit,
    setValue: referenceDetails,
  } = useForm();
  const {
    register: referenceSecondRegister,
    formState: { errors: referenceSecondErrors, isDirty: referenceSecondForm },
    handleSubmit: referenceSecondSubmit,
    setValue: referenceSecondDetails,
  } = useForm();
  const {
    register: otpRegister,
    formState: { errors: otpErrors, isDirty: otpForm },
    handleSubmit: otpSubmit,
    setValue: otpDetails,
  } = useForm();

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const userId = localStorage.getItem("id");
  const [formData, setFormData] = useState({});

  useEffect(() => {
    getUserData();
    getCoApplicantData();
    getRefernceData();
  }, []);

  const getUserData = async () => {
    const response = await getUserByUserId(userId);
    console.log("User Data by Id ==>", response.data);
    setUsergetData(response.data);
    Object.keys(response.data).forEach((key) => {
      userDetails(key, response.data[key]);
      docDetails(key, response.data[key]);
      personalDocDetails(key, response.data[key]);
      workDocDetails(key, response.data[key]);
    });
    console.log("User Data state ==>", usergetData);
  };
  const getCoApplicantData = async () => {
    const response = await getCoApplicantByUserId(userId);
    setCoApplicantGetData(response.data);
    console.log("Co applicant data--->", response.data);
    Object.keys(response.data).forEach((key) => {
      setValue(key, response.data[key]);
      coApplicantDetailsDetails(key, response.data[key]);
      coApplicantDetails(key, response.data[key]);
    });
  };
  const getRefernceData = async () => {
    const response = await getReferenceByUserId(userId);
    console.log("Reference Details -->", response.data[0]);
    if (response && response.data && response.data.length > 0) {
      console.log("Reference Details -->", response.data[0]);
      Object.keys(response.data[0]).forEach((key) => {
        console.log("response.data[0][key]", response.data[0][key]);
        referenceDetails(key, response.data[0][key]);
      });
      Object.keys(response.data[1]).forEach((key) => {
        console.log("response.data[0][key]", response.data[1][key]);
        referenceSecondDetails(key, response.data[1][key]);
      });
    } else {
      console.log("No reference data found.");
    }
  };

  const onSubmitUserData = async (data) => {
    console.log("form state -->", isDirty);
    const userData = {
      ...data,
      userId: userId,
    };
    console.log("Use form -->",userForm);

    if (!userForm && userData) {
      setUserData(false);
      setUserDoc1(true);
      console.log("Navigating to next form...");
    } else {
      if (userForm && userData.id) {
        const response = await updateUserDetails(userData.id, userData);
        console.log("User creation loan data --->", response);
        if (response.status === 200 || response.status === 201) {
          topEndLoan();
          setUserData(false);
          setUserDoc1(true);
        } else {
          Error();
        }
      } else {
        console.log("Apply loan user add data --->", userData);
        const response = await addUserDetails(userData);
        console.log("User creation loan data --->", response);
        if (response.status === 200 || response.status === 201) {
          topEndLoan();
          setUserData(false);
          setUserDoc1(true);
        } else {
          Error();
        }
      }
    }
  };

  function getLastTenCharactersOrString(inputString) {
    if (typeof inputString !== "string") {
      return "Input is not a string";
    }

    if (inputString.length >= 32) {
      return inputString.substring(32);
    } else {
      return inputString;
    }
  }
  const handleFileUpload = (name) => {
    const fileInput = document.getElementById(name);
    if (fileInput) {
      fileInput.click();
    } else {
      console.error(`Element with id ${name} not found`);
    }
  };

  const onSubmitUserDoc = async (data) => {
    console.log("is dirt-->", docForm);
    let Files = [];
    if (typeof data.tenthClass != "string") {
      let tenthData = {
        fieldName: "tenth",
        file: data.tenthClass,
      };
      Files.push(tenthData);
    }
    if (typeof data.adharCard != "string") {
      let adharData = {
        fieldName: "adharcard",
        file: data.adharCard,
      };
      Files.push(adharData);
    }
    if (typeof data.inter != "string") {
      let interData = {
        fieldName: "inter",
        file: data.inter,
      };
      Files.push(interData);
    }
    if (typeof data.underGraduation != "string") {
      let underGraduationData = {
        fieldName: "undergraduation",
        file: data.underGraduation,
      };
      Files.push(underGraduationData);
    }
    console.log("files", Files);
    if (!docForm) {
      setUserDoc1(false);
      setUserDoc2(true);
      console.log("user doc 1-->", userDoc1);
      console.log("user doc 2-->", userDoc2);
    } else if (docForm) {
      console.log("uploadedFiles-->", Files);
      console.log("sbmited data", data);
      for (const file of Files) {
        console.log("single file-->", file);
        try {
          const formData = new FormData();
          formData.append("files", file.file[0]);
          const response = await uploadUserProfile(
            userId,
            file.fieldName,
            formData
          );
          if (response.status === 200 || response.status === 201) {
            topEndLoan();
            setUserDoc1(false);
            setUserDoc2(true);
          }
        } catch (error) {
          console.error("Error uploading file:", error);
        }
      }
    }
  };

  const onSubmitUserDoc1 = async (data) => {
    console.log("sbmited data", data);
    let Files = [];
    if (typeof data.passportSizePhoto != "string") {
      let passportsizephoto = {
        fieldName: "passportsizephoto",
        file: data.passportSizePhoto,
      };
      Files.push(passportsizephoto);
    }
    if (typeof data.passport != "string") {
      let passport = {
        fieldName: "passport",
        file: data.passport,
      };
      Files.push(passport);
    }
    if (typeof data.panCard != "string") {
      let pancard = {
        fieldName: "pancard",
        file: data.panCard,
      };
      Files.push(pancard);
    }
    if (typeof data.other != "string") {
      let other = {
        fieldName: "other",
        file: data.other,
      };
      Files.push(other);
    }
    console.log("personalDocErrors", personalDocForm);
    if (!personalDocForm) {
      console.log("1");
      setUserDoc2(false);
      setUserDoc3(true);
    } else if (personalDocForm) {
      console.log("2");
      for (const file of Files) {
        console.log("single file-->", file.file);
        try {
          const formData = new FormData();
          formData.append("files", file.file[0]);
          const response = await uploadUserProfile(
            userId,
            file.fieldName,
            formData
          );
          if (response.status === 200 || response.status === 201) {
            topEndLoan();
            setUserDoc2(false);
            setUserDoc3(true);
          }
        } catch (error) {
          console.error("Error uploading file:", error);
        }
      }
    }
  };

  const onSubmitUserDoc2 = async (data) => {
    console.log("sbmited data", data);
    let Files = [];
    if (typeof data.workExperienceLetter != "string") {
      let workExperienceLetter = {
        fieldName: "workExperienceLetter",
        file: data.workExperienceLetter,
      };
      Files.push(workExperienceLetter);
    }
    if (typeof data.offerLetter != "string") {
      let offerLetter = {
        fieldName: "offerLetter",
        file: data.offerLetter,
      };
      Files.push(offerLetter);
    }
    if (typeof data.paySlips != "string") {
      let paySlips = {
        fieldName: "paySlips",
        file: data.paySlips,
      };
      Files.push(paySlips);
    }
    if (typeof data.relievingLetter != "string") {
      let relievingLetter = {
        fieldName: "relievingLetter",
        file: data.relievingLetter,
      };
      Files.push(relievingLetter);
    }
    if (typeof data.testScoreCards != "string") {
      let testScoreCards = {
        fieldName: "testScoreCards",
        file: data.testScoreCards,
      };
      Files.push(testScoreCards);
    }
    if (typeof data.propertyDocuments != "string") {
      let testScoreCards = {
        fieldName: "propertyDocuments",
        file: data.propertyDocuments,
      };
      Files.push(testScoreCards);
    }

    console.log("final files data-->", Files);
    if (!workDocForm) {
      setUserDoc3(false);
      setCoApplicant(true);
    } else if (workDocForm) {
      for (const file of Files) {
        console.log("single file-->", file.file);
        try {
          const formData = new FormData();
          formData.append("files", file.file[0]);
          const response = await uploadUserProfile(
            userId,
            file.fieldName,
            formData
          );
          if (response.status === 200 || response.status === 201) {
            topEndLoan();
            setUserDoc3(false);
            setCoApplicant(true);
          }
        } catch (error) {
          console.error("Error uploading file:", error);
        }
      }
    }
  };

  const onSubmitCoApplicantsData = async (data) => {
    const coApplicantData = {
      ...coapplicantGetData,
      ...data,
      userId: userId,
    };
    console.log("Co applicant Data-->", coApplicantData);
    if (!coApplicantDetailsForm && coApplicantData) {
      setCoApplicant(false);
      setCoApplicantDoc(true);
    } else if (coApplicantDetailsForm) {
      if (coApplicantDetailsForm && coApplicantData.id) {
        const response = await updateCoApplicantsDetails(
          coApplicantData.id,
          coApplicantData
        );
        if (response.status === 200 || response.status === 201) {
          topEndLoan();
          setCoApplicant(false);
          setCoApplicantDoc(true);
        }
        console.log("CoApplicants Data-->", response);
      } else {
        const response = await addCoApplicantsDetails(coApplicantData);
        if (response.status === 200 || response.status === 201) {
          topEndLoan();
          setCoApplicant(false);
          setCoApplicantDoc(true);
        }
      }
    }
  };
  const onSubmitCoApplicantsDocuments = async (data) => {
    let Files = [];
    if (typeof data.panCard != "string") {
      let panCard = {
        fieldName: "pancard",
        file: data.panCard,
      };
      Files.push(panCard);
    }
    if (typeof data.adarCard != "string") {
      let adarCard = {
        fieldName: "adarcard",
        file: data.adarCard,
      };
      Files.push(adarCard);
    }
    if (typeof data.paySlips != "string") {
      let paySlips = {
        fieldName: "payslips",
        file: data.paySlips,
      };
      Files.push(paySlips);
    }
    if (typeof data.bankStatement != "string") {
      let bankStatement = {
        fieldName: "bankstatement",
        file: data.bankStatement,
      };
      Files.push(bankStatement);
    }
    if (typeof data.itrform16 != "string") {
      let itrform16 = {
        fieldName: "itrform16",
        file: data.itrform16,
      };
      Files.push(itrform16);
    }
    console.log("Co applicant data-->", data);
    if (!coApplicantForm) {
      setCoApplicantDoc(false);
      setReference1(true);
    } else {
      for (const file of Files) {
        console.log("single file-->", file.file);
        try {
          const formData = new FormData();
          formData.append("file", file.file[0]);
          const response = await uploadCoApplicantsDetails(
            userId,
            file.fieldName,
            formData
          );
          if (response.status === 200 || response.status === 201) {
            topEndLoan();
            setCoApplicantDoc(false);
            setReference1(true);
          }
        } catch (error) {
          console.error("Error uploading file:", error);
        }
      }
    }
    console.log("Co-applicants ", data);
  };
  const onSubmitReference1 = async (data) => {
    console.log("addresss-->", data);
    const ReferenceData = {
      ...data,
      userId: userId,
    };
    if (!referenceForm) {
      setReference1(false);
      setReference2(true);
    } else if (referenceForm) {
      if (referenceForm && ReferenceData.id) {
        const response = await updateReferenceDetails(
          ReferenceData.id,
          ReferenceData
        );
        console.log("Response of reference -->", response);
        if (response.status === 200 || response.status === 201) {
          topEndLoan();
          setReference1(false);
          setReference2(true);
        }
      } else {
        const response = await addReferenceDetails(ReferenceData);
        console.log("Response of reference -->", response);
        if (response.status === 200 || response.status === 201) {
          topEndLoan();
          setReference1(false);
          setReference2(true);
        }
      }
    }
  };
  const onSubmitReference2 = async (data) => {
    console.log("addresss-->", data);
    const ReferenceData = {
      ...data,
      userId: userId,
    };
    if (!referenceSecondForm) {
      setReference2(false);
      setVeification(true);
    } else if (referenceSecondForm) {
      if (referenceSecondForm && ReferenceData.id) {
        const response = await updateReferenceDetails(
          ReferenceData.id,
          ReferenceData
        );
        console.log("Response of reference -->", response);
        if (response.status === 200 || response.status === 201) {
          topEndLoan();
          setReference1(false);
          setReference2(true);
        }
      } else {
        const response = await addReferenceDetails(ReferenceData);
        console.log("Response of reference -->", response);
        if (response.status === 200 || response.status === 201) {
          topEndLoan();
          setReference2(false);
          setVeification(true);
        }
      }
    }
  };
  const [showOtpField, setShowOtpField] = useState(false);
  const onSubmitVerification = async (data) => {
    if (
      data.name === usergetData.fullName &&
      data.phoneNumber === usergetData.phoneNumber
    ) {
      const phoneNumber = "+" + data.phoneNumber;
      console.log("Data confirmed success ------/------------");
      console.log("phone --->", phoneNumber);
      const response = await sendMoblieOTPapi(phoneNumber);
      console.log("OTP response --->", response);
      if(response.status == 200 || response.status == 201){
        setShowOtpField(true);
      }
    } else {
      WarningAlert("Phone Number or Name doesnot match with previous...")
      console.log("not matched ----/---");
    }
    console.log(data);
  };
  const onSubmitOTP = async (data) => {
    const response = await handleMobileOtpSubmit(usergetData.phoneNumber,data.resetToken);
    console.log(" OTP response --->",response);
    if(response.status == 200 && response.data.status == true){
      setVeification(false);
      setUserData(true);
      registersuccess("Loan Application Successfully submitted...");
    }
  };
  return (
    <>
      <div className="main-wrapper">
        {/* Header */}
        <Header />

        {/* Sidebar */}
        <SideBar />

        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title mt-2">Apply Loan </h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/admindashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">Apply Loan</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}

            <div className="card card-table cardimages formdata">
              <div>
                {" "}
                <img
                  src={logopart}
                  alt="imagesside"
                  className="imagessidelogo1"
                />
              </div>
              {userData && (
                <>
                  <div className="card form-card ">
                    <div>
                      <img
                        src={edudoc}
                        alt="formimage"
                        className="form_image"
                      />
                    </div>
                    <form onSubmit={userSubmit(onSubmitUserData)}>
                      <div className="form-inputdata">
                        <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                          <label>
                            Full Name
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${
                              userErrors.fullName ? "is-invalid" : ""
                            }`}
                            value={formData.fullName}
                            {...userRegister("fullName", { required: true })}
                          />
                          {userErrors.fullName && (
                            <span className="text-danger">
                              Full Name is required
                            </span>
                          )}
                        </div>

                        <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                          <label>
                            Email
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            type="email"
                            className={`form-control ${
                              userErrors.email ? "is-invalid" : ""
                            }`}
                            value={formData.email}
                            {...userRegister("email", { required: true })}
                          />
                          {userErrors.email && (
                            <span className="text-danger">
                              Email is required
                            </span>
                          )}
                        </div>

                        <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                          <label>
                            Phone Number
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            type="tel"
                            className={`form-control ${
                              userErrors.phoneNumber ? "is-invalid" : ""
                            }`}
                            placeholder="enter With country code"
                            value={formData.phoneNumber}
                            {...userRegister("phoneNumber", {
                              required: true,
                              validate: (value) => {
                                return value.length === 12;
                              }
                            })}
                          />
                          {userErrors.phoneNumber && (
                            <span className="text-danger">
                              Please enter a valid 12-digit phone number with country code.
                            </span>
                          )}
                        </div>
                        <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                          <label>
                            Planning to which country?
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${
                              userErrors.planningTo ? "is-invalid" : ""
                            }`}
                            value={formData.planningTo}
                            {...userRegister("planningTo", { required: true })}
                          />
                          {userErrors.planningTo && (
                            <span className="text-danger">
                              Country is required
                            </span>
                          )}
                        </div>
                        <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                          <label>
                            Choose the bank for a loan
                            <span className="login-danger">*</span>
                          </label>
                          <select
                            className={`form-control ${
                              userErrors.chooseBank ? "is-invalid" : ""
                            }`}
                            value={formData.chooseBank}
                            {...userRegister("chooseBank", { required: true })}
                          >
                            <option value="">Choose Bank</option>
                            <option value="AXIS BANK">AXIS BANK</option>
                            <option value="SBI BANK">SBI BANK</option>
                            <option value="ICICI BANK">ICICI BANK</option>
                            <option value="KOTAK BANK">KOTAK BANK</option>
                            <option value="HDFC BANK">HDFC BANK</option>
                          </select>
                          {userErrors.chooseBank && (
                            <span className="error-message">
                              This field is required
                            </span>
                          )}
                        </div>

                        <button
                          type="submit" // Change type to "button"
                          className="btn btn-primary applybutton"
                        >
                          Next
                        </button>
                      </div>
                    </form>
                  </div>
                </>
              )}

              {userDoc1 && (
                <>
                  <form
                    onSubmit={docSubmit(onSubmitUserDoc)}
                    className="card form-card"
                  >
                    <div className="formdivapply">
                      <h4>Educational Documents</h4>

                      <div className="row">
                        <div className="form-group col-12 col-md-6">
                          <div className="card" style={{ width: 260 }}>
                            <h6 className="patag">
                              Upload the 10th Certificate
                            </h6>
                            <div
                              className="settings-btn p-2"
                              onClick={() => handleFileUpload("tenthClass")}
                            >
                              {usergetData.tenthClass && (
                                <div>
                                  {getLastTenCharactersOrString(
                                    usergetData.tenthClass
                                  )}
                                </div>
                              )}
                              <input
                                type="file"
                                accept="file/*"
                                name="tenthClass"
                                id="tenthClass"
                                className={` ${
                                  docErrors.tenthClass &&
                                  (isDirty || isSubmitted)
                                    ? "is-invalid"
                                    : ""
                                }`}
                                style={{
                                  display: usergetData.tenthClass
                                    ? "none"
                                    : "block",
                                }}
                                {...docRegister("tenthClass", {
                                  required: !usergetData.tenthClass,
                                })}
                                aria-invalid={
                                  docErrors.tenthClass ? "true" : "false"
                                }
                              />
                              <label htmlFor="file" className="upload">
                                <i className="feather-upload">
                                  <FeatherIcon icon="upload" />
                                </i>
                              </label>
                            </div>
                          </div>
                          {docErrors.tenthClass && (
                            <p role="alert" style={{ color: "red" }}>
                              Document is required
                            </p>
                          )}
                        </div>
                        <div className="form-group col-12 col-md-6">
                          <div className="card" style={{ width: 260 }}>
                            <h6 className="patag">
                              Upload the 12th Certificate
                            </h6>
                            <div
                              className="settings-btn p-2"
                              onClick={() => handleFileUpload("inter")}
                            >
                              {usergetData.inter && (
                                <div>
                                  {getLastTenCharactersOrString(
                                    usergetData.inter
                                  )}
                                </div>
                              )}
                              <input
                                type="file"
                                accept="file/*"
                                name="inter"
                                id="inter"
                                className={` ${
                                  docErrors.inter && (isDirty || isSubmitted)
                                    ? "is-invalid"
                                    : ""
                                }`}
                                style={{
                                  display: usergetData.inter ? "none" : "block",
                                }}
                                {...docRegister("inter", {
                                  required: !usergetData.inter,
                                })}
                                aria-invalid={
                                  docErrors.inter ? "true" : "false"
                                }
                              />
                              <label htmlFor="file" className="upload">
                                <i className="feather-upload">
                                  <FeatherIcon icon="upload" />
                                </i>
                              </label>
                            </div>
                          </div>
                          {docErrors.inter && (
                            <p role="alert" style={{ color: "red" }}>
                              Document is required
                            </p>
                          )}
                        </div>
                        <div className="form-group col-12 col-md-6">
                          <div className="card" style={{ width: 260 }}>
                            <h6 className="patag">
                              Upload Student Bachelors UG Marks Sheet
                            </h6>
                            <div
                              className="settings-btn p-2"
                              onClick={() =>
                                handleFileUpload("underGraduation")
                              }
                            >
                              {usergetData.underGraduation && (
                                <div>
                                  {getLastTenCharactersOrString(
                                    usergetData.underGraduation
                                  )}
                                </div>
                              )}
                              <input
                                type="file"
                                accept="file/*"
                                name="underGraduation"
                                id="underGraduation"
                                className={` ${
                                  docErrors.underGraduation &&
                                  (isDirty || isSubmitted)
                                    ? "is-invalid"
                                    : ""
                                }`}
                                style={{
                                  display: usergetData.underGraduation
                                    ? "none"
                                    : "block",
                                }}
                                {...docRegister("underGraduation", {
                                  required: !usergetData.underGraduation,
                                })}
                                aria-invalid={
                                  docErrors.underGraduation ? "true" : "false"
                                }
                              />
                              <label htmlFor="file" className="upload">
                                <i className="feather-upload">
                                  <FeatherIcon icon="upload" />
                                </i>
                              </label>
                            </div>
                          </div>
                          {docErrors.underGraduation?.type === "required" && (
                            <p role="alert" style={{ color: "red" }}>
                              Document is required
                            </p>
                          )}
                        </div>

                        <div className="form-group col-12 col-md-6">
                          <div className="card" style={{ width: 260 }}>
                            <h6 className="patag">Upload Aadhar Card</h6>
                            <div
                              className="settings-btn p-2"
                              onClick={() => handleFileUpload("adharCard")}
                            >
                              {usergetData.adharCard && (
                                <div>
                                  {getLastTenCharactersOrString(
                                    usergetData.adharCard
                                  )}
                                </div>
                              )}
                              <input
                                type="file"
                                accept="file/*"
                                name="adharCard"
                                id="adharCard"
                                className={` ${
                                  docErrors.adharCard &&
                                  (docForm || isSubmitted)
                                    ? "is-invalid"
                                    : ""
                                }`}
                                style={{
                                  display: usergetData.adharCard
                                    ? "none"
                                    : "block",
                                }}
                                {...docRegister("adharCard", {
                                  required: !usergetData.adharCard,
                                })}
                                aria-invalid={
                                  docErrors.adharCard ? "true" : "false"
                                }
                              />
                              <label htmlFor="file" className="upload">
                                <i className="feather-upload">
                                  <FeatherIcon icon="upload" />
                                </i>
                              </label>
                            </div>
                          </div>
                          {docErrors.adharCard && (
                            <p role="alert" style={{ color: "red" }}>
                              Document is required
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="button-group12">
                        <button
                          type="button"
                          className="btn btn-primary applybutton"
                          onClick={() => {
                            setUserDoc1(false);
                            setUserData(true);
                          }}
                        >
                          Prev
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary applybutton"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </form>
                </>
              )}

              {userDoc2 && (
                <>
                  <div className="card form-card ">
                    <div className="formdivapply">
                      <h4>Personal Documents</h4>
                      <form onSubmit={personalDocSubmit(onSubmitUserDoc1)}>
                        <div className="row">
                          <div className="form-group col-12 col-md-6">
                            <div className="card" style={{ width: 260 }}>
                              <h6 className="patag">
                                Upload Student Passport Size Photo
                              </h6>
                              <div
                                className="settings-btn p-2"
                                onClick={() =>
                                  handleFileUpload("passportSizePhoto")
                                }
                              >
                                {usergetData.passportSizePhoto && (
                                  <div>
                                    {getLastTenCharactersOrString(
                                      usergetData.passportSizePhoto
                                    )}
                                  </div>
                                )}
                                <input
                                  type="file"
                                  accept="file/*"
                                  name="passportSizePhoto"
                                  id="passportSizePhoto"
                                  className={` ${
                                    personalDocErrors.passportSizePhoto &&
                                    (docForm || isSubmitted)
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  style={{
                                    display: usergetData.passportSizePhoto
                                      ? "none"
                                      : "block",
                                  }}
                                  {...personalRegister("passportSizePhoto", {
                                    required: !usergetData.passportSizePhoto,
                                  })}
                                  aria-invalid={
                                    personalDocErrors.passportSizePhoto
                                      ? "true"
                                      : "false"
                                  }
                                />
                                <label htmlFor="file" className="upload">
                                  <i className="feather-upload">
                                    <FeatherIcon icon="upload" />
                                  </i>
                                </label>
                              </div>
                            </div>
                            {personalDocErrors.passportSizePhoto && (
                              <p role="alert" style={{ color: "red" }}>
                                Document is required
                              </p>
                            )}
                          </div>

                          <div className="form-group col-12 col-md-6">
                            <div className="card" style={{ width: 260 }}>
                              <h6 className="patag">Upload Passport</h6>
                              <div
                                className="settings-btn p-2"
                                onClick={() => handleFileUpload("passport")}
                              >
                                {usergetData.passport && (
                                  <div>
                                    {getLastTenCharactersOrString(
                                      usergetData.passport
                                    )}
                                  </div>
                                )}
                                <input
                                  type="file"
                                  accept="file/*"
                                  name="passport"
                                  id="passport"
                                  className={` ${
                                    personalDocErrors.passport &&
                                    (docForm || isSubmitted)
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  style={{
                                    display: usergetData.passport
                                      ? "none"
                                      : "block",
                                  }}
                                  {...personalRegister("passport", {
                                    required: !usergetData.passport,
                                  })}
                                  aria-invalid={
                                    personalDocErrors.passport
                                      ? "true"
                                      : "false"
                                  }
                                />
                                <label htmlFor="file" className="upload">
                                  <i className="feather-upload">
                                    <FeatherIcon icon="upload" />
                                  </i>
                                </label>
                              </div>
                            </div>
                            {personalDocErrors.passport && (
                              <p role="alert" style={{ color: "red" }}>
                                Document is required
                              </p>
                            )}
                          </div>

                          <div className="form-group col-12 col-md-6">
                            <div className="card" style={{ width: 260 }}>
                              <h6 className="patag">Upload Student Pancard</h6>
                              <div
                                className="settings-btn p-2"
                                onClick={() => handleFileUpload("pancard")}
                              >
                                {usergetData.panCard && (
                                  <div>
                                    {getLastTenCharactersOrString(
                                      usergetData.panCard
                                    )}
                                  </div>
                                )}
                                <input
                                  type="file"
                                  accept="file/*"
                                  name="pancard"
                                  id="pancard"
                                  className={` ${
                                    personalDocErrors.panCard &&
                                    (docForm || isSubmitted)
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  style={{
                                    display: usergetData.panCard
                                      ? "none"
                                      : "block",
                                  }}
                                  {...personalRegister("panCard", {
                                    required: !usergetData.panCard,
                                  })}
                                  aria-invalid={
                                    personalDocErrors.panCard ? "true" : "false"
                                  }
                                />
                                <label htmlFor="file" className="upload">
                                  <i className="feather-upload">
                                    <FeatherIcon icon="upload" />
                                  </i>
                                </label>
                              </div>
                            </div>
                            {personalDocErrors.panCard && (
                              <p role="alert" style={{ color: "red" }}>
                                Document is required
                              </p>
                            )}
                          </div>

                          <div className="form-group col-12 col-md-6">
                            <div className="card" style={{ width: 260 }}>
                              <h6 className="patag">Other</h6>
                              <div
                                className="settings-btn p-2"
                                onClick={() => handleFileUpload("other")}
                              >
                                {usergetData.other && (
                                  <div>
                                    {getLastTenCharactersOrString(
                                      usergetData.other
                                    )}
                                  </div>
                                )}
                                <input
                                  type="file"
                                  accept="file/*"
                                  name="other"
                                  id="other"
                                  className={` ${
                                    personalDocErrors.other &&
                                    (docForm || isSubmitted)
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  style={{
                                    display: usergetData.other
                                      ? "none"
                                      : "block",
                                  }}
                                  {...personalRegister("other", {
                                    required: false,
                                  })}
                                  aria-invalid={
                                    personalDocErrors.other ? "true" : "false"
                                  }
                                />
                                <label htmlFor="file" className="upload">
                                  <i className="feather-upload">
                                    <FeatherIcon icon="upload" />
                                  </i>
                                </label>
                              </div>
                            </div>
                            {personalDocErrors.other && (
                              <p role="alert" style={{ color: "red" }}>
                                Document is required
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="button-group12">
                          <button
                            type="button"
                            className="btn btn-primary applybutton"
                            onClick={() => {
                              setUserDoc2(false);
                              setUserDoc1(true);
                            }}
                          >
                            Prev
                          </button>
                          <button
                            type="submit"
                            className="btn btn-primary applybutton"
                          >
                            Next
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </>
              )}

              {coApplicant && (
                <>
                  <div className="card form-card ">
                    {/* <p>pjhfjpfgpj</p> */}

                    <div>
                      <img
                        src={edudoc}
                        alt="formimage"
                        className="form_image"
                      />
                    </div>
                    <form
                      onSubmit={coApplicantDetailsSubmit(
                        onSubmitCoApplicantsData
                      )}
                    >
                      <div className="form-inputdata">
                        <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                          <label>
                            Co-applicant’s Full name
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${
                              coApplicantDetailsErrors.coApplicantFullName
                                ? "is-invalid"
                                : ""
                            }`}
                            {...coApplicantDetailsRegister(
                              "coApplicantFullName",
                              {
                                required: true,
                              }
                            )}
                          />
                          {errors.coApplicantFullName && (
                            <span className="text-danger">
                              This field is required
                            </span>
                          )}
                        </div>
                        <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                          <label>
                            Co-Applicant Phone Number :
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${
                              coApplicantDetailsErrors.coApplicantPhoneNumber
                                ? "is-invalid"
                                : ""
                            }`}
                            {...coApplicantDetailsRegister(
                              "coApplicantPhoneNumber",
                              {
                                required: true,
                              }
                            )}
                          />
                          {coApplicantDetailsErrors.coApplicantPhoneNumber && (
                            <span className="text-danger">
                              This field is required
                            </span>
                          )}
                        </div>
                        <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                          <label>
                            Co-applicant’s Relationship
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${
                              coApplicantDetailsErrors.coApplicantRelationShip
                                ? "is-invalid"
                                : ""
                            }`}
                            {...coApplicantDetailsRegister(
                              "coApplicantRelationShip",
                              {
                                required: true,
                              }
                            )}
                          />
                          {coApplicantDetailsErrors.coApplicantRelationShip && (
                            <span className="text-danger">
                              This field is required
                            </span>
                          )}
                        </div>
                        <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                          <label>
                            Employment type
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${
                              coApplicantDetailsErrors.employmentType
                                ? "is-invalid"
                                : ""
                            }`}
                            {...coApplicantDetailsRegister("employmentType", {
                              required: true,
                            })}
                          />
                          {coApplicantDetailsErrors.employmentType && (
                            <span className="text-danger">
                              This field is required
                            </span>
                          )}
                        </div>
                        <div className="form-group  form-groupapply col-12 col-sm-4 local-forms">
                          <label>
                            Own house co-applicant
                            <span className="login-danger">*</span>
                          </label>
                          <select
                            className={`form-control ${
                              coApplicantDetailsErrors.ownHouseCoApplicant
                                ? "is-invalid"
                                : ""
                            }`}
                            {...coApplicantDetailsRegister(
                              "ownHouseCoApplicant",
                              {
                                required: true,
                              }
                            )}
                          >
                            <option value="">Select one</option>
                            <option value="yes">Yes</option>
                            <option value="no">No</option>
                          </select>
                          {coApplicantDetailsErrors.ownHouseCoApplicant && (
                            <span className="text-danger">
                              This field is required
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="button-group12">
                        <button
                          type="button"
                          className="btn btn-primary applybutton"
                          onClick={() => {
                            setUserDoc3(false);
                            setUserDoc2(true);
                          }}
                        >
                          Prev
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary applybutton"
                        >
                          Next
                        </button>
                      </div>
                    </form>
                  </div>
                </>
              )}
              {coApplicantDoc && (
                <>
                  <div className="card form-card ">
                    <form
                      onSubmit={coApplicantSubmit(
                        onSubmitCoApplicantsDocuments
                      )}
                    >
                      <div className="row p-2">
                        <div className="col-12 col-md-6">
                          <div className="card mb-2" style={{ width: 260 }}>
                            <h6 className="patag">Pan Card</h6>
                            <div
                              className="settings-btn p-2"
                              onClick={() => handleFileUpload("panCard")}
                            >
                              {coapplicantGetData.panCard && (
                                <div>
                                  {getLastTenCharactersOrString(
                                    coapplicantGetData.panCard
                                  )}
                                </div>
                              )}
                              <input
                                type="file"
                                accept="file/*"
                                name="panCard"
                                id="panCard"
                                className={` ${
                                  coApplicantErrors.panCard &&
                                  (isDirty || isSubmitted)
                                    ? "is-invalid"
                                    : ""
                                }`}
                                style={{
                                  display: coapplicantGetData.panCard
                                    ? "none"
                                    : "block",
                                }}
                                {...coApplicantRegister("panCard", {
                                  required: !coapplicantGetData.panCard,
                                })}
                                aria-invalid={
                                  coApplicantErrors.panCard ? "true" : "false"
                                }
                              />
                              <label htmlFor="file" className="upload">
                                <i className="feather-upload">
                                  <FeatherIcon icon="upload" />
                                </i>
                              </label>
                            </div>
                          </div>
                          {coApplicantErrors.panCard?.type === "required" && (
                            <p role="alert" style={{ color: "red" }}>
                              Document is required
                            </p>
                          )}
                        </div>
                        <div className="col-12 col-md-6">
                          <div className="card mb-2" style={{ width: 260 }}>
                            <h6 className="patag">Adar Card</h6>
                            <div
                              className="settings-btn p-2"
                              onClick={() => handleFileUpload("adarCard")}
                            >
                              {coapplicantGetData.adarCard && (
                                <div>
                                  {getLastTenCharactersOrString(
                                    coapplicantGetData.adarCard
                                  )}
                                </div>
                              )}
                              <input
                                type="file"
                                accept="file/*"
                                name="adarCard"
                                id="adarCard"
                                className={` ${
                                  coApplicantErrors.adarCard &&
                                  (isDirty || isSubmitted)
                                    ? "is-invalid"
                                    : ""
                                }`}
                                style={{
                                  display: coapplicantGetData.adarCard
                                    ? "none"
                                    : "block",
                                }}
                                {...coApplicantRegister("adarCard", {
                                  required: !coapplicantGetData.adarCard,
                                })}
                                aria-invalid={
                                  coApplicantErrors.adarCard ? "true" : "false"
                                }
                              />
                              <label htmlFor="file" className="upload">
                                <i className="feather-upload">
                                  <FeatherIcon icon="upload" />
                                </i>
                              </label>
                            </div>
                          </div>
                          {coApplicantErrors.adarCard?.type === "required" && (
                            <p role="alert" style={{ color: "red" }}>
                              Document is required
                            </p>
                          )}
                        </div>
                        <div className="col-12 col-md-6">
                          <div className="card mb-2" style={{ width: 260 }}>
                            <h6 className="patag">Bank Statement</h6>
                            <div
                              className="settings-btn p-2"
                              onClick={() => handleFileUpload("bankStatement")}
                            >
                              {coapplicantGetData.bankStatement && (
                                <div>
                                  {getLastTenCharactersOrString(
                                    coapplicantGetData.bankStatement
                                  )}
                                </div>
                              )}
                              <input
                                type="file"
                                accept="file/*"
                                name="bankStatement"
                                id="bankStatement"
                                className={` ${
                                  coApplicantErrors.bankStatement &&
                                  (isDirty || isSubmitted)
                                    ? "is-invalid"
                                    : ""
                                }`}
                                style={{
                                  display: coapplicantGetData.bankStatement
                                    ? "none"
                                    : "block",
                                }}
                                {...coApplicantRegister("bankStatement", {
                                  required: !coapplicantGetData.bankStatement,
                                })}
                                aria-invalid={
                                  coApplicantErrors.bankStatement
                                    ? "true"
                                    : "false"
                                }
                              />
                              <label htmlFor="file" className="upload">
                                <i className="feather-upload">
                                  <FeatherIcon icon="upload" />
                                </i>
                              </label>
                            </div>
                          </div>
                          {coApplicantErrors.bankStatement?.type ===
                            "required" && (
                            <p role="alert" style={{ color: "red" }}>
                              Document is required
                            </p>
                          )}
                        </div>
                        <div className="col-12 col-md-6">
                          <div className="card mb-2" style={{ width: 260 }}>
                            <h6 className="patag">Pay Slips</h6>
                            <div
                              className="settings-btn p-2"
                              onClick={() => handleFileUpload("paySlips")}
                            >
                              {coapplicantGetData.paySlips && (
                                <div>
                                  {getLastTenCharactersOrString(
                                    coapplicantGetData.paySlips
                                  )}
                                </div>
                              )}
                              <input
                                type="file"
                                accept="file/*"
                                name="paySlips"
                                id="paySlips"
                                className={` ${
                                  coApplicantErrors.paySlips &&
                                  (isDirty || isSubmitted)
                                    ? "is-invalid"
                                    : ""
                                }`}
                                style={{
                                  display: coapplicantGetData.paySlips
                                    ? "none"
                                    : "block",
                                }}
                                {...coApplicantRegister("paySlips", {
                                  required: !coapplicantGetData.paySlips,
                                })}
                                aria-invalid={
                                  coApplicantErrors.paySlips ? "true" : "false"
                                }
                              />
                              <label htmlFor="file" className="upload">
                                <i className="feather-upload">
                                  <FeatherIcon icon="upload" />
                                </i>
                              </label>
                            </div>
                          </div>
                          {coApplicantErrors.paySlips?.type === "required" && (
                            <p role="alert" style={{ color: "red" }}>
                              Document is required
                            </p>
                          )}
                        </div>
                        <div className="col-12 col-md-6">
                          <div className="card mb-2" style={{ width: 260 }}>
                            <h6 className="patag">ITR Form16</h6>
                            <div
                              className="settings-btn p-2"
                              onClick={() => handleFileUpload("itrform16")}
                            >
                              {coapplicantGetData.itrform16 && (
                                <div>
                                  {getLastTenCharactersOrString(
                                    coapplicantGetData.itrform16
                                  )}
                                </div>
                              )}
                              <input
                                type="file"
                                accept="file/*"
                                name="itrform16"
                                id="itrform16"
                                className={` ${
                                  coApplicantErrors.itrform16 &&
                                  (isDirty || isSubmitted)
                                    ? "is-invalid"
                                    : ""
                                }`}
                                style={{
                                  display: coapplicantGetData.itrform16
                                    ? "none"
                                    : "block",
                                }}
                                {...coApplicantRegister("itrform16", {
                                  required: !coapplicantGetData.itrform16,
                                })}
                                aria-invalid={
                                  coApplicantErrors.itrform16 ? "true" : "false"
                                }
                              />
                              <label htmlFor="file" className="upload">
                                <i className="feather-upload">
                                  <FeatherIcon icon="upload" />
                                </i>
                              </label>
                            </div>
                          </div>
                          {coApplicantErrors.itrform16?.type === "required" && (
                            <p role="alert" style={{ color: "red" }}>
                              Document is required
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="button-group12">
                        <button
                          type="button"
                          className="btn btn-primary applybutton"
                          onClick={() => {
                            setCoApplicant(false);
                            setUserDoc3(true);
                          }}
                        >
                          Prev
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary applybutton"
                        >
                          Next
                        </button>
                      </div>
                    </form>
                  </div>
                </>
              )}
              {userDoc3 && (
                <>
                  <div className="card form-card">
                    <form onSubmit={workDocSubmit(onSubmitUserDoc2)}>
                      <div className="row p-2">
                        <div className="col-12 col-md-6">
                          <div className="card mb-0" style={{ width: 260 }}>
                            <h6 className="patag">Work exp letter</h6>
                            <div
                              className="settings-btn p-2"
                              onClick={() =>
                                handleFileUpload("workExperienceLetter")
                              }
                            >
                              {usergetData.workExperienceLetter && (
                                <div>
                                  {getLastTenCharactersOrString(
                                    usergetData.workExperienceLetter
                                  )}
                                </div>
                              )}
                              <input
                                type="file"
                                accept="file/*"
                                name="workExperienceLetter"
                                id="workExperienceLetter"
                                className={` ${
                                  workDocErrors.workExperienceLetter &&
                                  (docForm || isSubmitted)
                                    ? "is-invalid"
                                    : ""
                                }`}
                                style={{
                                  display: usergetData.workExperienceLetter
                                    ? "none"
                                    : "block",
                                }}
                                {...workRegister("workExperienceLetter", {
                                  required: !usergetData.workExperienceLetter,
                                })}
                                aria-invalid={
                                  workDocErrors.workExperienceLetter
                                    ? "true"
                                    : "false"
                                }
                              />
                              <label htmlFor="file" className="upload">
                                <i className="feather-upload">
                                  <FeatherIcon icon="upload" />
                                </i>
                              </label>
                            </div>
                          </div>
                          {workDocErrors.workExperienceLetter && (
                            <p role="alert" style={{ color: "red" }}>
                              Document is required
                            </p>
                          )}
                        </div>

                        <div className="col-12 col-md-6">
                          <div className="card mb-0" style={{ width: 260 }}>
                            <h6 className="patag">Offer letter</h6>
                            <div
                              className="settings-btn p-2"
                              onClick={() => handleFileUpload("offerLetter")}
                            >
                              {usergetData.offerLetter && (
                                <div>
                                  {getLastTenCharactersOrString(
                                    usergetData.offerLetter
                                  )}
                                </div>
                              )}
                              <input
                                type="file"
                                accept="file/*"
                                name="offerLetter"
                                id="offerLetter"
                                className={` ${
                                  workDocErrors.offerLetter &&
                                  (docForm || isSubmitted)
                                    ? "is-invalid"
                                    : ""
                                }`}
                                style={{
                                  display: usergetData.offerLetter
                                    ? "none"
                                    : "block",
                                }}
                                {...workRegister("offerLetter", {
                                  required: !usergetData.offerLetter,
                                })}
                                aria-invalid={
                                  workDocErrors.offerLetter ? "true" : "false"
                                }
                              />
                              <label htmlFor="file" className="upload">
                                <i className="feather-upload">
                                  <FeatherIcon icon="upload" />
                                </i>
                              </label>
                            </div>
                          </div>
                          {workDocErrors.offerLetter && (
                            <p role="alert" style={{ color: "red" }}>
                              Document is required
                            </p>
                          )}
                        </div>

                        <div className=" col-12 col-md-6">
                          <div className="card mb-0" style={{ width: 260 }}>
                            <h6 className="patag">Payslips</h6>
                            <div
                              className="settings-btn p-2"
                              onClick={() => handleFileUpload("paySlips")}
                            >
                              {usergetData.paySlips && (
                                <div>
                                  {getLastTenCharactersOrString(
                                    usergetData.paySlips
                                  )}
                                </div>
                              )}
                              <input
                                type="file"
                                accept="file/*"
                                name="paySlips"
                                id="paySlips"
                                className={` ${
                                  workDocErrors.paySlips &&
                                  (docForm || isSubmitted)
                                    ? "is-invalid"
                                    : ""
                                }`}
                                style={{
                                  display: usergetData.paySlips
                                    ? "none"
                                    : "block",
                                }}
                                {...workRegister("paySlips", {
                                  required: !usergetData.paySlips,
                                })}
                                aria-invalid={
                                  workDocErrors.paySlips ? "true" : "false"
                                }
                              />
                              <label htmlFor="file" className="upload">
                                <i className="feather-upload">
                                  <FeatherIcon icon="upload" />
                                </i>
                              </label>
                            </div>
                          </div>
                          {workDocErrors.paySlips && (
                            <p role="alert" style={{ color: "red" }}>
                              Document is required
                            </p>
                          )}
                        </div>

                        <div className="col-12 col-md-6">
                          <div className="card mb-0" style={{ width: 260 }}>
                            <h6 className="patag">
                              Relieving letter ( If you have )
                            </h6>
                            <div
                              className="settings-btn p-2"
                              onClick={() => handleFileUpload("relivingLetter")}
                            >
                              {usergetData.relivingLetter && (
                                <div>
                                  {getLastTenCharactersOrString(
                                    usergetData.relivingLetter
                                  )}
                                </div>
                              )}
                              <input
                                type="file"
                                accept="file/*"
                                name="relivingLetter"
                                id="relivingLetter"
                                className={` ${
                                  workDocErrors.relivingLetter &&
                                  (docForm || isSubmitted)
                                    ? "is-invalid"
                                    : ""
                                }`}
                                style={{
                                  display: usergetData.relivingLetter
                                    ? "none"
                                    : "block",
                                }}
                                {...workRegister("relivingLetter", {
                                  required: false,
                                })}
                                aria-invalid={
                                  workDocErrors.relivingLetter
                                    ? "true"
                                    : "false"
                                }
                              />
                              <label htmlFor="file" className="upload">
                                <i className="feather-upload">
                                  <FeatherIcon icon="upload" />
                                </i>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-6">
                          <div className="card mb-0" style={{ width: 260 }}>
                            <h6 className="patag">Student’s Test scorecards</h6>
                            <div
                              className="settings-btn p-2"
                              onClick={() => handleFileUpload("testScoreCards")}
                            >
                              {usergetData.testScoreCards && (
                                <div>
                                  {getLastTenCharactersOrString(
                                    usergetData.testScoreCards
                                  )}
                                </div>
                              )}
                              <input
                                type="file"
                                accept="file/*"
                                name="testScoreCards"
                                id="testScoreCards"
                                className={` ${
                                  workDocErrors.testScoreCards &&
                                  (workDocErrors || isSubmitted)
                                    ? "is-invalid"
                                    : ""
                                }`}
                                style={{
                                  display: usergetData.testScoreCards
                                    ? "none"
                                    : "block",
                                }}
                                {...workRegister("testScoreCards", {
                                  required: !usergetData.testScoreCards,
                                })}
                                aria-invalid={
                                  workDocErrors.testScoreCards
                                    ? "true"
                                    : "false"
                                }
                              />
                              <label htmlFor="file" className="upload">
                                <i className="feather-upload">
                                  <FeatherIcon icon="upload" />
                                </i>
                              </label>
                            </div>
                          </div>
                          {workDocErrors.testScoreCards && (
                            <p role="alert" style={{ color: "red" }}>
                              Document is required
                            </p>
                          )}
                        </div>
                        <div className="col-12 col-md-6">
                          <div className="card mb-0" style={{ width: 260 }}>
                            <h6 className="patag">
                              upload the property document
                            </h6>
                            <div
                              className="settings-btn p-2"
                              onClick={() =>
                                handleFileUpload("propertyDocuments")
                              }
                            >
                              {usergetData.propertyDocuments && (
                                <div>
                                  {getLastTenCharactersOrString(
                                    usergetData.propertyDocuments
                                  )}
                                </div>
                              )}
                              <input
                                type="file"
                                accept="file/*"
                                name="propertyDocuments"
                                id="propertyDocuments"
                                className={` ${
                                  workDocErrors.propertyDocuments &&
                                  (docForm || isSubmitted)
                                    ? "is-invalid"
                                    : ""
                                }`}
                                style={{
                                  display: usergetData.propertyDocuments
                                    ? "none"
                                    : "block",
                                }}
                                {...workRegister("propertyDocuments", {
                                  required: !usergetData.propertyDocuments,
                                })}
                                aria-invalid={
                                  workDocErrors.propertyDocuments
                                    ? "true"
                                    : "false"
                                }
                              />
                              <label htmlFor="file" className="upload">
                                <i className="feather-upload">
                                  <FeatherIcon icon="upload" />
                                </i>
                              </label>
                            </div>
                          </div>
                          {workDocErrors.propertyDocuments && (
                            <p role="alert" style={{ color: "red" }}>
                              Document is required
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="button-group12">
                        <button
                          className="btn btn-primary applybutton"
                          onClick={() => {
                            setCoApplicantDoc(false);
                            setCoApplicant(true);
                          }}
                        >
                          Prev
                        </button>
                        <button
                          className="btn btn-primary applybutton"
                          onClick={() => {
                            // Handle next button click
                          }}
                        >
                          Next
                        </button>
                      </div>
                    </form>
                  </div>
                </>
              )}
              {reference1 && (
                <>
                  <div className="card form-card ">
                    <div>
                      <img
                        src={edudoc}
                        alt="formimage"
                        className="form_image"
                      />
                    </div>
                    <form onSubmit={referenceSubmit(onSubmitReference1)}>
                      <div className="form-inputdata">
                        <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                          <label>
                            Reference 1 Name
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            {...referenceRegister("name", { required: true })}
                          />
                          {referenceErrors.name && (
                            <span className="error-message">
                              This field is required
                            </span>
                          )}
                        </div>
                        <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                          <label>
                            Reference 1 Phone number
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            {...referenceRegister("phoneNumber", {
                              required: true,
                            })}
                          />
                          {referenceErrors.phoneNumber && (
                            <span className="error-message">
                              This field is required
                            </span>
                          )}
                        </div>
                        <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                          <label>
                            Reference 1 houseNumber
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            {...referenceRegister("addressDTO.houseNumber", {
                              required: true,
                            })}
                          />
                          {referenceErrors.reference2Address && (
                            <span className="error-message">
                              This field is required
                            </span>
                          )}
                        </div>
                        <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                          <label>
                            Reference 1 apartment
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            {...referenceRegister("addressDTO.apartment", {
                              required: true,
                            })}
                          />
                          {referenceErrors.reference2Address && (
                            <span className="error-message">
                              This field is required
                            </span>
                          )}
                        </div>
                        <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                          <label>
                            Reference 1 city
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            {...referenceRegister("addressDTO.city", {
                              required: true,
                            })}
                          />
                          {referenceErrors.reference2Address && (
                            <span className="error-message">
                              This field is required
                            </span>
                          )}
                        </div>
                        <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                          <label>
                            Reference 1 state
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            {...referenceRegister("addressDTO.state", {
                              required: true,
                            })}
                          />
                          {referenceErrors.reference2Address && (
                            <span className="error-message">
                              This field is required
                            </span>
                          )}
                        </div>
                        <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                          <label>
                            Reference 1 pinCode
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            {...referenceRegister("addressDTO.pinCode", {
                              required: true,
                            })}
                          />
                          {referenceErrors.reference2Address && (
                            <span className="error-message">
                              This field is required
                            </span>
                          )}
                        </div>
                        <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                          <label>
                            Reference 1 country
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            {...referenceRegister("addressDTO.country", {
                              required: true,
                            })}
                          />
                          {referenceErrors.reference2Address && (
                            <span className="error-message">
                              This field is required
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="button-group12">
                        <button
                          type="button"
                          className="btn btn-primary applybutton"
                          onClick={() => {
                            setReference1(false);
                            setCoApplicantDoc(true);
                          }}
                        >
                          Prev
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary applybutton"
                        >
                          Next
                        </button>
                      </div>
                    </form>
                  </div>
                </>
              )}
              {reference2 && (
                <>
                  <div className="card form-card ">
                    <div>
                      <img
                        src={edudoc}
                        alt="formimage"
                        className="form_image"
                      />
                    </div>
                    <form onSubmit={referenceSecondSubmit(onSubmitReference2)}>
                      <div className="form-inputdata">
                        <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                          <label>
                            Reference 2 Name
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            {...referenceSecondRegister("name", {
                              required: true,
                            })}
                          />
                          {referenceSecondErrors.name && (
                            <span className="error-message">
                              This field is required
                            </span>
                          )}
                        </div>
                        <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                          <label>
                            Reference 2 Phone number
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            {...referenceSecondRegister("phoneNumber", {
                              required: true,
                            })}
                          />
                          {referenceSecondErrors.phoneNumber && (
                            <span className="error-message">
                              This field is required
                            </span>
                          )}
                        </div>
                        <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                          <label>
                            Reference 2 houseNumber
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            {...referenceSecondRegister(
                              "addressDTO.houseNumber",
                              {
                                required: true,
                              }
                            )}
                          />
                          {referenceSecondErrors.reference2Address && (
                            <span className="error-message">
                              This field is required
                            </span>
                          )}
                        </div>
                        <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                          <label>
                            Reference 2 apartment
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            {...referenceSecondRegister(
                              "addressDTO.apartment",
                              {
                                required: true,
                              }
                            )}
                          />
                          {referenceSecondErrors.reference2Address && (
                            <span className="error-message">
                              This field is required
                            </span>
                          )}
                        </div>
                        <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                          <label>
                            Reference 2 city
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            {...referenceSecondRegister("addressDTO.city", {
                              required: true,
                            })}
                          />
                          {referenceSecondErrors.reference2Address && (
                            <span className="error-message">
                              This field is required
                            </span>
                          )}
                        </div>
                        <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                          <label>
                            Reference 2 state
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            {...referenceSecondRegister("addressDTO.state", {
                              required: true,
                            })}
                          />
                          {referenceSecondErrors.reference2Address && (
                            <span className="error-message">
                              This field is required
                            </span>
                          )}
                        </div>
                        <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                          <label>
                            Reference 2 pinCode
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            {...referenceSecondRegister("addressDTO.pinCode", {
                              required: true,
                            })}
                          />
                          {referenceSecondErrors.reference2Address && (
                            <span className="error-message">
                              This field is required
                            </span>
                          )}
                        </div>
                        <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                          <label>
                            Reference 2 country
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            {...referenceSecondRegister("addressDTO.country", {
                              required: true,
                            })}
                          />
                          {referenceSecondErrors.reference2Address && (
                            <span className="error-message">
                              This field is required
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="button-group12">
                        <button
                          type="button"
                          className="btn btn-primary applybutton"
                          onClick={() => {
                            setReference2(false);
                            setReference1(true);
                          }}
                        >
                          Prev
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary applybutton"
                        >
                          Next
                        </button>
                      </div>
                    </form>
                  </div>
                </>
              )}
              {veification && (
                <>
                  <div className="card form-card ">
                    <div>
                      <img
                        src={edudoc}
                        alt="formimage"
                        className="form_image"
                      />
                    </div>
                    <form onSubmit={verificationSubmit(onSubmitVerification)}>
                      {!showOtpField && (
                        <>
                          <div className="row">
                            <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                              <label>
                                Name
                                <span className="login-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className={`form-control ${
                                  errors.name ? "is-invalid" : ""
                                }`}
                                {...verificationRegister("name", {
                                  required: true,
                                })}
                              />
                              {verificationErrors.name && (
                                <span className="text-danger">
                                  This field is required
                                </span>
                              )}
                            </div>
                            <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                              <label>
                                Phone Number
                                <span className="login-danger">*</span>
                              </label>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  className={`form-control ${
                                    verificationErrors.phoneNumber
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  {...verificationRegister("phoneNumber", {
                                    required: true,
                                    pattern: {
                                      value: /^\d{12}$/,
                                      message: "Please enter a 12-digit number without special symbols",
                                    },
                                    validate: (value) => {
                                      return value.length === 12;
                                    }
                                  })}
                                  placeholder="Number with country code without +"
                                />
                              </div>
                              {verificationErrors.phoneNumber && (
                                <span className="text-danger">
                                  Please enter a 12-digit number without special symbols
                                </span>
                              )}
                            </div>

                            <div className="button-group12">
                              <button
                                type="button"
                                className="btn btn-primary applybutton"
                                onClick={() => {
                                  setVeification(false);
                                  setReference2(true);
                                }}
                              >
                                Prev
                              </button>
                              <button
                                type="submit"
                                className="btn btn-primary applybutton"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </>
                      )}

                      {showOtpField && (
                        <div className="form-group form-groupapply col-12 col-sm-4 local-forms">
                          <label>
                            OTP
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${
                              otpErrors.resetToken ? "is-invalid" : ""
                            }`}
                            {...otpRegister("resetToken", { required: true })}
                          />
                          {otpErrors.resetToken && (
                            <span className="text-danger">
                              This field is required
                            </span>
                          )}

                          <div className="button-group12">
                            <button
                              type="button"
                              className="btn btn-primary applybutton"
                              onClick={() => setShowOtpField(false)}
                            >
                              Resend OTP
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary applybutton"
                              onClick={otpSubmit(onSubmitOTP)}
                            >
                              Verify
                            </button>
                          </div>
                        </div>
                      )}
                    </form>
                  </div>
                </>
              )}
            </div>
          </div>
          {/* Footer */}
          <Footer />
        </div>
      </div>
      {/* /Main Wrapper */}
    </>
  );
}
